<script>
  import {scoresStore}          from '../../../../../stores/filters/scores-store';
  import {results5LimitedStore} from '../../../../../stores/results/results-5-limited-store';

  export let stat;
  export let score;

  const isInteger = score % 1 === 0;
  const isLeftColumn = score === 0.25;
  const isBottomRow = stat.name === 'Invincibility';

  $: maxScore = $results5LimitedStore.maxScores[stat.index];
  $: activeFilter = $scoresStore.find((f) => f.stat.name === stat.name);
  $: activeFilterScore = activeFilter && activeFilter.score;
  $: unavailable = score > maxScore;
  $: highlighted = activeFilterScore >= score;
  $: disabled = unavailable && !highlighted;

  const onClick = (_event) => {
    scoresStore.toggle(stat, score);
  };
</script>

<style>
  .score-box {
    border-bottom: none;
    border-left: 1px solid #ccc;
    border-right: none;
    border-top: 1px solid #333;
  }

  .stat-score-disabled {
    border-left-color: #777;
    border-right-color: #777;
  }

  .stat-score-disabled {
    cursor: not-allowed;
  }
</style>

<template lang="pug" src="./stat-filter-score.pug"></template>
